import {
  AfterContentInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  inject,
  WritableSignal,
  signal,
} from '@angular/core';
import { buildPayload, ContentFlex } from '@ckmk/angular';
import { FrontHeader } from '@app/src/app/components/front-header/front-header';
import { PostFilter } from '@app/src/app/modules/post/components/post-filter/post-filter';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import { PostCard } from '@app/src/app/modules/post/components/post-card/post-card';
import { PostService } from '@app/src/app/modules/post/service/post.service';

@Component({
  selector: 'post-list',
  standalone: true,
  imports: [FrontHeader, PostFilter, PostCard, ContentFlex],
  templateUrl: './post-list.html',
  styleUrl: './post-list.scss',
  host: {
    '[class.is-loading]': 'loading()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class PostList
  implements OnInit, OnChanges, OnDestroy, AfterContentInit
{
  protected readonly self = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly service = inject(PostService);

  protected readonly posts: WritableSignal<PostModel[]> = signal<PostModel[]>(
    [],
  );

  protected readonly loading: WritableSignal<boolean> = signal<boolean>(false);

  protected readonly currentPage: WritableSignal<number> = signal<number>(1);

  protected readonly maxItems: WritableSignal<number> = signal<number>(20);

  public constructor() {}

  public ngOnInit() {
    this.service.posts.onQuery((response, loading) => {
      this.loading.set(loading);

      if (!loading && response) {
        this.posts.set(response);
      }
    });

    this.loadPosts();
  }

  public ngOnChanges(changes: SimpleChanges) {}

  public ngOnDestroy() {
    this.service.posts.unsubscribe(true);
  }

  public ngAfterContentInit() {}

  protected loadPosts() {
    this.service.posts.watchQuery(
      buildPayload()
        .into('payload', (builder) =>
          builder
            .setMultiple({
              includeCategory: true,
              includePicture: true,
            })
            .paginate(this.currentPage(), this.maxItems()),
        )
        .build() as any,
    );
  }
}
